import { Component, OnInit } from '@angular/core';
import { ASSETS } from '@core/constants/assets.constants';
import { APP_ROUTES } from '@core/constants/routes.constants';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { CommonModule } from '@angular/common';
import { UserProfile } from '@core/models/user.model';
import { AuthService } from '@core/auth/services/auth.service';
import { USER_ROLE, Workflow_Status } from '@app/core/enums/common.enums';

interface MenuItem {
  label: string;
  icon: string;
  routerLink: string;
  ROLES: string[];
}

@Component({
  selector: 'app-main-header',
  imports: [CommonModule, RouterLink, RouterLinkActive],
  templateUrl: './main-header.html',
  styleUrl: './main-header.scss',
})
//todo: cleanup code
export class MainHeader implements OnInit {
  ASSETS = ASSETS;
  APP_ROUTES = APP_ROUTES;
  isAuthenticated = false;
  firstName = 'John';
  lastName = 'Doe';
  useProfilePicture = true;
  profilePicturePath = ASSETS.background.AUTH.LOGIN.BACKGROUND;

  userProfile: UserProfile | null | undefined = null;
  profilePictureUrl: string | null = null;
  accessDashboard = false;
  subscribed = false;

  constructor(
    private authService: AuthService,
    private router: Router,
  ) {}

  ngOnInit() {
    this.authService.userProfile$.subscribe((user) => {
      this.userProfile = user;
      this.profilePictureUrl = user?.profilePicturePath
        ? this.getImageUrlWithCacheBust(user.profilePicturePath)
        : null;
      this.accessDashboard =
        user?.workFlowStatus === Workflow_Status.subscribedActive &&
        (user?.role === USER_ROLE.ORG_ADMIN ||
          user?.role === USER_ROLE.ORG_OWNER ||
          user?.role === USER_ROLE.ORG_APP_USER ||
          user?.role === USER_ROLE.ORG_SURVEY_USER);
      this.subscribed =
        user?.workFlowStatus === Workflow_Status.subscribedActive &&
        user?.role === USER_ROLE.ORG_OWNER;
    });
  }
  getImageUrlWithCacheBust(url: string): string {
    if (!url) return url;
    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}t=${Date.now()}`;
  }

  logout() {
    this.authService.logout();
    this.router.navigate([APP_ROUTES.AUTH.ROOT, APP_ROUTES.AUTH.SIGNIN]);
  }

  routeLink = {
    dashboard: '/workspace/dashboard',
    upgrade: '/workspace/upgrade',
    helpCenter: '/workspace/help-center',
    questionnaire: '/workspace/questionnaire',
    setup: '/setup',
    reports: '/workspace/reports',
    myAccount: '/my-account',
  };

  leftMenuItems: MenuItem[] = [
    {
      label: 'My Workspace',
      icon: 'bi bi-ui-checks-grid',
      routerLink: this.routeLink.questionnaire,
      ROLES: [
        USER_ROLE.ORG_ADMIN,
        USER_ROLE.ORG_OWNER,
        USER_ROLE.ORG_APP_USER,
        USER_ROLE.ORG_SURVEY_USER,
      ],
    },

    {
      label: 'Integration Settings',
      icon: 'fas fa-cog',
      routerLink: this.routeLink.setup,
      ROLES: [USER_ROLE.ORG_ADMIN, USER_ROLE.ORG_OWNER, USER_ROLE.ORG_APP_USER],
    },
    // {
    //   label: 'Reports',
    //   icon: 'fas fa-chart-bar',
    //   routerLink: this.routeLink.reports,
    //   ROLES: [
    //     USER_ROLE.ORG_ADMIN,
    //     USER_ROLE.ORG_OWNER,
    //     USER_ROLE.ORG_APP_USER,
    //     USER_ROLE.ORG_SURVEY_USER,
    //   ],
    // },
  ];

  // Check if user has access to a menu item based on role
  hasAccessToMenuItem(item: MenuItem): boolean {
    if (!this.userProfile?.role) {
      return false;
    }
    return item.ROLES.includes(this.userProfile.role);
  }

  // Get filtered menu items based on user role
  get filteredLeftMenuItems(): MenuItem[] {
    if (!this.userProfile?.role) {
      return [];
    }
    return this.leftMenuItems.filter((item) => this.hasAccessToMenuItem(item));
  }
}
